<template>
  <span></span>
</template>

<script>
  import store from  '@/store/store'
  export default {
    name: 'Auth',
    components: {
      
    },
    data() {
      return {
      }
    },
    
  
    created() {
      const full_hash_param = this.$route.params.id_token;
      let required_token;
      if (full_hash_param) { 
        const id_token = full_hash_param;
        const id_token_array = id_token.split('&');
        id_token_array.forEach(element => {
            if (element.includes("id_token")){
            required_token = element.substring(9);
            }
        });
      } 
      
      if (required_token){
        const id_token_arr = required_token.split('.');
        const user = JSON.parse(atob(id_token_arr[1]));
        store.commit('add_id_token', required_token);
        store.commit('add_user',user);
      }
      this.user = store.state.user["cognito:username"];
      if (this.user){
        this.$router.push({ name: 'User'});
      }
      else {
        location.replace("https://authentication.simtekz.com/login?client_id=3l505p8r7gtfsd4upctv22f6nh&response_type=token&scope=email+openid+phone&redirect_uri=https://simtekz.com");
      }
    },
    
  }
</script>

<style scoped>

</style>